var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoreeChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5303 17.0303C12.2374 17.3232 11.7626 17.3232 11.4697 17.0303L2.46967 8.03033C2.17678 7.73744 2.17678 7.26256 2.46967 6.96967C2.76256 6.67678 3.23744 6.67678 3.53033 6.96967L12 15.4393L20.4697 6.96967C20.7626 6.67678 21.2374 6.67678 21.5303 6.96967C21.8232 7.26256 21.8232 7.73744 21.5303 8.03033L12.5303 17.0303Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoreeChevronDown);
export default __webpack_public_path__ + "static/media/loree-chevron-down.43b8ab03d8624b50a152bed87390840d.svg";
export { ForwardRef as ReactComponent };